export default __webpack_public_path__ + "img/69640a00a7a06cbe86f6b0737067c28b.png";